import React, { useEffect, useRef, useState, useContext } from 'react'
import { Helmet } from "react-helmet";
import { BrowserRouter, useNavigate, Link, Route, Routes, Switch } from "react-router-dom";
import Nav from '../Components/Nav';
import Sidebar from '../Components/Sidebar';
import { f, database, storage, auth } from "../config";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import firebase from "firebase";
import Swal from 'sweetalert2'

function Security() {
        const [navOpen, setNavOpen] = useState(false); // Toggle state for Nav

    useEffect(() => {
  if (window.innerWidth >= 1024) { // example breakpoint for large screens
    setNavOpen(true);
  }
}, []);
 // Toggle state for Nav
    
      // Toggle function for Nav
      const handleToggleSidebar = () => {
        setNavOpen(!navOpen);
      };
    

    const save = () => {
        Swal.fire({
            icon: 'success',
            title: 'Account has been updated successfully',
            showConfirmButton: false,
            timer: 1500
        })
    }
    return (
        <div>
                <Helmet>
                  <script src="dashboard/js"></script>
                  <script src="dashboard/js/bootstrap.bundle.min.js"></script>
                  <script src="dashboard/js/modernizr.js"></script>
                  <script src="dashboard/js/moment.js"></script>
                  <script src="dashboard/js/megamenu.js"></script>
                  <script src="dashboard/js/custom.js"></script>
                  <script src="dashboard/js/slimscroll.min.js"></script>
                  <script src="dashboard/js/custom-scrollbar.js"></script>
                  <script src="dashboard/js/search-filter.js"></script>
                  <script src="dashboard/js/custom-search-filter.js"></script>
                  <script src="dashboard/js/apexcharts.min.js"></script>
                  <script src="dashboard/js/salesGraph.js"></script>
                  <script src="dashboard/js/ordersGraph.js"></script>
                  <script src="dashboard/js/earningsGraph.js"></script>
                  <script src="dashboard/js/visitorsGraph.js"></script>
                  <script src="dashboard/js/customersGraph.js"></script>
                  <script src="dashboard/js/sparkline.js"></script>
                  <script src="dashboard/js/circliful.min.js"></script>
                  <script src="dashboard/js/circliful.custom.js"></script>
                  <script src="dashboard/js/main.js"></script>
                  
                  <style>{`
                    /* Nav toggle styles */
                    .nav-wrapper {
                      transition: transform 0.3s ease-in-out;
                    }
                    
                    .nav-wrapper.nav-hidden .sidebar-wrapper {
                      transform: translateX(-100%) !important;
                    }
                    
                    .nav-wrapper.nav-visible .sidebar-wrapper {
                      transform: translateX(0) !important;
                    }
                    
                    /* Adjust main container margin */
                    .main-container {
                      transition: margin-left 0.3s ease-in-out;
                    }
                    
                    .page-wrapper.nav-closed .main-container {
                      margin-left: 0 !important;
                    }
                    
                    /* Toggle button cursor */
                    .toggle-sidebar {
                      cursor: pointer !important;
                    }
                    
                    /* Mobile responsive */
                    @media (max-width: 991px) {
                      .nav-wrapper.nav-visible::before {
                        content: '';
                        position: fixed;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: rgba(0,0,0,0.5);
                        z-index: 998;
                      }
                    }
                  `}</style>
                </Helmet>
            {/* Loading wrapper end */}
            {/* Page wrapper start */}
      <div className={`page-wrapper ${!navOpen ? 'nav-closed' : ''}`}>
        {/* Nav wrapper with toggle control */}
        <div
          className={`nav-wrapper ${navOpen ? "nav-visible" : "nav-hidden"}`}
        >
          {navOpen ? <Nav /> : <></>}
        </div>
                {/* Sidebar wrapper end */}
                {/* *************
            ************ Main container start *************
        ************* */}
                <div className="main-container">
                    {/* Page header starts */}
                    <div className="page-header">
                        {/* Row start */}
                        <div className="row gutters">
                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-9">
                                {/* Search container start */}
                                <div className="search-container">
                                    {/* Toggle sidebar start */}
                                       <div 
                    className="toggle-sidebar" 
                    id="toggle-sidebar"
                    onClick={handleToggleSidebar}
                  >
                    <i className="icon-menu" />
                  </div>
                                    {/* Toggle sidebar end */}
                                </div>
                                {/* Search container end */}
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-3">
                                {/* Header actions start */}
                                <ul className="header-actions">
                                    <li className="dropdown">
                                        <a href="#" id="userSettings" className="user-settings" data-toggle="dropdown" aria-haspopup="true">
                                            Hi Qwertyy &nbsp;
                                            <span className="avatar">
                                                <img src="dashboard/img/user.svg" alt="User Avatar" />
                                                <span className="status busy" />
                                            </span>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-end md" aria-labelledby="userSettings">
                                            <div className="header-profile-actions">
                                                <a href="?a=edit_account"><i className="icon-user1" />Profile</a>
                                                <a href="?a=security"><i className="icon-warning" />Security</a>
                                                <a href="?a=logout"><i className="icon-log-out1" />Logout</a>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                {/* Header actions end */}
                            </div>
                        </div>
                        {/* Row end */}
                    </div>
                    {/* Page header ends */}
                    {/* Content wrapper scroll start */}
                    <div className="content-wrapper-scroll">
                        {/* Content wrapper start */}
                        <div className="content-wrapper">
                            {/* Row start */}
                            <div className="row gutters">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    {/* Card start */}
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-title">Advanced login security settings</div>
                                        </div>
                                        <div className="card-body">
                                            <form ><input type="hidden" name="form_id" defaultValue={16866893516564} /><input type="hidden" name="form_token" defaultValue="bfcda7b6123891328fb9aaca5b13f86e" />
                                                <input type="hidden" name="a" defaultValue="security" />
                                                <input type="hidden" name="action" defaultValue="save" />
                                                Detect IP Address Change Sensitivity<br />
                                                <input type="radio" name="ip" defaultValue="disabled" defaultChecked />Disabled<br />
                                                <input type="radio" name="ip" defaultValue="medium" />Medium<br />
                                                <input type="radio" name="ip" defaultValue="high" />High<br />
                                                <input type="radio" name="ip" defaultValue="always" />Paranoic<br /><br />
                                                Detect Browser Change<br />
                                                <input type="radio" name="browser" defaultValue="disabled" defaultChecked />Disabled<br />
                                                <input type="radio" name="browser" defaultValue="enabled" />Enabled<br /><br />
                                                <input type="button" defaultValue="Set" className="btn btn-primary ml-auto" onClick={save} />
                                            </form>
                                        </div></div></div>
                            </div></div>
                    </div></div>
            </div>
            {/* App footer start */}
            <div className="app-footer">© Acorn-mart</div>
        </div>
    )
}

export default Security